import React from 'react';
import PropTypes from 'prop-types';
import stringUtils from '../../../../qti/utils/StringUtils';
import IntervalSaver from '../../../../services/IntervalSaver';
import { t } from '../../../../services/i18nService';

class TextEntryStringInput extends React.PureComponent {
    static propTypes = {
        callback: PropTypes.func.isRequired, // callback(responseIdentifier, [simpleChoice identifiers])
        defaultValue: PropTypes.string,
        model: PropTypes.object.isRequired, // model taken from responseModels related to this interaction
        handleInteractionReady: PropTypes.func.isRequired,
        isReadOnly: PropTypes.bool,
        maxLength: PropTypes.number,
        size: PropTypes.number,
        orderNumber: PropTypes.string,
        questionModel: PropTypes.object,
        services: PropTypes.object,
        isActive: PropTypes.bool,
        isFlagged: PropTypes.bool,
        onChangeCallback: PropTypes.func,
        expandableInputStyles: PropTypes.object,
        keyword: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.instanceId = stringUtils.getUID();
        this.state = { instanceId: stringUtils.getUID() };
        this.smartSaver = new IntervalSaver(props.defaultValue, (value) => {
            props.callback(props.model.identifier, [value]);
        });
    }

    componentDidMount() {
        this.props.handleInteractionReady(true);
    }

    componentWillUnmount() {
        this.smartSaver.saveAndStop();
    }

    onChange = (e) => {
        const { onChangeCallback, model } = this.props;
        this.smartSaver.setValue(e.currentTarget.value);
        if (model.expandAutomatically && onChangeCallback) {
            onChangeCallback(this.inputElement.value);
        }
    };

    setValue(value) {
        this.inputElement.value = value;
    }

    navigateToScorableItem = () => {
        const { services, model, questionModel } = this.props;
        services.scorableItemNumberingService.navigateToScorableItem(questionModel.contentRevisionId, model.identifier, undefined, true);
    };

    render() {
        const {
            defaultValue,
            isReadOnly,
            maxLength,
            model,
            size,
            orderNumber,
            isActive,
            isFlagged,
            expandableInputStyles,
            keyword,
        } = this.props;
        const isActiveClass = isActive ? ' active' : '';
        const isFlaggedClass = isFlagged ? ' flagged' : '';
        const interactionTypeClass = model.interactionType ? ' graphic' : '';
        const className = `textEntryInteractionValue${interactionTypeClass}${isActiveClass}${isFlaggedClass}`;
        const style = model.expandAutomatically && expandableInputStyles ? expandableInputStyles : null;
        const labelMessage = t('interactions.textEntry.textFieldWrapperAriaLabel');
        const handler = (event) => {
            event.preventDefault();
            return false;
        };
        return (
            <label htmlFor={this.instanceId} aria-label={labelMessage}>
                <input
                    id={this.instanceId}
                    autoComplete="off"
                    className={className}
                    defaultValue={defaultValue}
                    disabled={isReadOnly}
                    maxLength={maxLength}
                    name={this.state.instanceId}
                    onChange={this.onChange}
                    onFocus={this.navigateToScorableItem}
                    onDrop={handler}
                    ref={(element) => {
                        this.inputElement = element;
                    }}
                    spellCheck="false"
                    size={size}
                    type="text"
                    placeholder={orderNumber}
                    style={style}
                    keyword={keyword}
                />
            </label>
        );
    }
}

export default TextEntryStringInput;
